/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { metaReachEstimateEstimate } from '../../axios/metaReachEstimateEstimate'
import type {
	MetaReachEstimateEstimateError,
	MetaReachEstimateEstimateQueryParams,
	MetaReachEstimateEstimateResponse,
} from '../../types/MetaReachEstimateEstimate'

export const metaReachEstimateEstimateQueryKey = (params?: MetaReachEstimateEstimateQueryParams) =>
	[{ url: '/meta/reach-estimate' }, ...(params ? [params] : [])] as const

export type MetaReachEstimateEstimateQueryKey = ReturnType<typeof metaReachEstimateEstimateQueryKey>

/** @see backend/nexus/modules/MetaAd/Http/Controllers/MetaReachEstimateController.php MetaReachEstimateController::estimate */
export function metaReachEstimateEstimateQueryOptions(
	params?: MetaReachEstimateEstimateQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		MetaReachEstimateEstimateResponse,
		AxiosError<MetaReachEstimateEstimateError>,
		MetaReachEstimateEstimateResponse,
		MetaReachEstimateEstimateQueryKey
	>({
		queryKey: metaReachEstimateEstimateQueryKey(params),
		queryFn: ({ signal }) => metaReachEstimateEstimate(params, { signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/MetaAd/Http/Controllers/MetaReachEstimateController.php MetaReachEstimateController::estimate */
export function useMetaReachEstimateEstimate<TSelectData = MetaReachEstimateEstimateResponse>(
	params?: MetaReachEstimateEstimateQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					MetaReachEstimateEstimateResponse,
					AxiosError<MetaReachEstimateEstimateError>,
					TSelectData,
					MetaReachEstimateEstimateQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<MetaReachEstimateEstimateError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...metaReachEstimateEstimateQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/MetaAd/Http/Controllers/MetaReachEstimateController.php MetaReachEstimateController::estimate */
export function useMetaReachEstimateEstimateSuspense<TSelectData = MetaReachEstimateEstimateResponse>(
	params?: MetaReachEstimateEstimateQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					MetaReachEstimateEstimateResponse,
					AxiosError<MetaReachEstimateEstimateError>,
					TSelectData,
					MetaReachEstimateEstimateQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<MetaReachEstimateEstimateError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...metaReachEstimateEstimateQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
